import { render, staticRenderFns } from "./Standings.vue?vue&type=template&id=cf72ed80&scoped=true"
import script from "./Standings.vue?vue&type=script&lang=js"
export * from "./Standings.vue?vue&type=script&lang=js"
import style0 from "./Standings.vue?vue&type=style&index=0&id=cf72ed80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf72ed80",
  null
  
)

export default component.exports